var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.938 2.333h-.444a.72.72 0 0 1-.653-.402L9.316.887A1.59 1.59 0 0 0 7.88 0H4.66a1.59 1.59 0 0 0-1.435.887L2.7 1.93a.72.72 0 0 1-.654.402h-.443A1.604 1.604 0 0 0 0 3.938V9.77a1.604 1.604 0 0 0 1.604 1.604h9.334a1.604 1.604 0 0 0 1.604-1.604V3.938a1.604 1.604 0 0 0-1.604-1.605m-4.667 7a3.063 3.063 0 1 1 0-6.125 3.063 3.063 0 0 1 0 6.125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.271 8.459a2.187 2.187 0 1 0 0-4.375 2.187 2.187 0 0 0 0 4.375"
  })));
};
export default SvgCamera;